import MemberInterface from '../models/member-interface'

const membersData: MemberInterface[] = [
    {
        name: 'Ana Clara',
        url: 'https://www.linkedin.com/in/anaclaraoliveiradejesus/',
    },
    {
        name: 'André Rodrigues da Cruz',
        url: 'http://lattes.cnpq.br/3346655862356439',
    },
     {
        name: 'Beatriz Siqueira Campos',
        url: 'https://www.linkedin.com/in/beatriz-siqueira-campos/',
    },
    {
        name: 'Daniel Santos',
        url: 'https://www.linkedin.com/in/daniel-santos-aaa612164/',
    },
    {
        name: 'Diogo Santos',
        url: 'https://www.linkedin.com/in/diogo-emanuel-antunes-santos-23579b221',
    },
    {
        name: 'Gustavo Brito',
        url: 'https://www.linkedin.com/in/gustavobritodam/',
    },
    {
        name: 'Jônata Cirqueira',
        url: 'https://www.linkedin.com/in/j%C3%B4nata-cirqueira-748b3b174/',
    },
    {
        name: 'Julio Cesar Rocha',
        url: 'https://linkedin.com/in/juliocros',
    },
    {
        name: 'Pedro César Mesquita Ferreira',
        url: 'https://linktr.ee/pcmferreira',
    },
    {
        name: 'Rodrigo Novaes',
        url: 'https://linkedin.com/in/rrnovaesjr',
    },
    {
        name: 'Sandro Renato Dias',
        url: 'https://linkedin.com/in/sandrord',
    },
]

export default membersData
